import React from "react";
import "./Projects.css";

const getStatusClass = (status) => {
  const s = status.toLowerCase();
  if (s.includes("complete")) return "status-completed";
  if (s.includes("progress") || s.includes("ongoing")) return "status-progress";
  return "status-other";
};

const projects = [
  {
    title: "DOZAi - AI Documentation Platform",
    status: "Completed",
    description:
      "AI-powered documentation generator built with Spring Boot and Google Gemini API. Reduced documentation time by 60% through intelligent automation. Deployed on Huawei ECS with Nginx, AWS S3 storage, and CI/CD pipelines via GitHub Actions.",
    link: "https://doz-ai-ai-documentation-generation.vercel.app/",
    image: "images/dozai.png",
  },
  {
    title: "Walter Sisulu Municipality IT Help Desk System",
    status: "Completed",
    description:
      "Full-stack IT help desk system enabling ticket submission, assignment, and resolution tracking for 100+ users. Built with Vue.js, Node.js, Spring Boot, and PostgreSQL. Deployed on AWS EC2 with role-based access control for secure workflows.",
    link: "https://wslm-helpdesk-frontend.onrender.com/",
    image: "images/wslm.webp",
  },
  {
    title: "Split - Group Wallet (NetBank API)",
    status: "In Progress",
    description:
      "A group wallet platform for friends and families to manage shared expenses on trips, restaurants, and events. Built using NetBank Wallet API, enabling seamless contributions, tracking, and real-time balance management.",
    link: null,
    image: "images/slipt.png",
  },
  {
    title: "AnimeGate",
    status: "Completed",
    description:
      "Anime streaming platform featuring real-time discussions via Twitter API, secure payment integration, and JWT-based authentication for scalable user access.",
    link: "https://animegate.com",
    image:
      "images/anime-girl-with-long-hair-pink-kimono-generative-ai_901242-40983.jpg",
  },
  {
    title: "Sports Betting GUI",
    status: "Completed",
    description:
      "Java-based sports betting interface using Swing and SQL for managing MMA athlete data. Applied database normalization and OOP principles. Achieved a 96% academic score.",
    link: "https://github.com/SA-Ntlanganiso/SportBetting2-UI",
    image: "images/playing.jpg",
  },
  {
    title: "Affiliated E-commerce Store",
    status: "Completed",
    description:
      "Price comparison platform leveraging web scraping from Takealot and Temu to help users make better purchasing decisions through real-time pricing insights.",
    link: null,
    image: "images/ecomm.png",
  },
];

const ProjectsDashboard = () => (
  <div className="content">
    <div className="page-header">
      <p className="page-eyebrow">Portfolio</p>
      <h2>Projects</h2>
      <p className="page-subtitle">A selection of production-ready systems I've built</p>
    </div>

    <div className="projects-container">
      {projects.map((project, index) => (
        <div className="project-box" key={index}>
          <div className="project-img-wrap">
            <img
              src={project.image}
              alt={project.title}
              className="project-image"
            />
          </div>

          <div className="project-body-wrap">
            <header>
              <h3>{project.title}</h3>
              <span
                className={`project-status ${getStatusClass(project.status)}`}
              >
                {project.status}
              </span>
            </header>

            <div className="project-body">
              <p>{project.description}</p>

              {project.link && (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  View Project ↗
                </a>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ProjectsDashboard;